<template>
  <div>
    <el-dialog
      title="批量创建扣款计划"
      :visible.sync="dialogVisible"
      width="824px"
      :before-close="closeDialog"

    >
      <div>
        <QS-h4-title title="扣款规则设置" no-decorate></QS-h4-title>
        <el-form
          :inline="true"
          ref="formRef"
          label-width="120px"
          :model="formData"
        >
          <el-form-item
            prop="paymentMode"
            label="扣款周期"
            label-width="93px"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择扣款周期',
            }"
          >
            <el-select
              v-model="formData.paymentMode"
              placeholder="请选择"
              @change="paymentModeChange"
            >
              <el-option :key="1" label="日扣" :value="1"></el-option>
              <el-option :key="2" label="周扣" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <!-- 日扣时间选择 -->
          <el-form-item
            v-if="formData.paymentMode === 1"
            prop="gmtTime"
            label="扣款执行周期"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择扣款执行周期',
            }"
          >
            <div class="flex">
              <el-date-picker
                v-model="formData.gmtTime"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                placeholder="请选择日期"
                clearable
                :picker-options="pickerOptions"
                @change="getTime"
              ></el-date-picker>
              <div v-if="days" class="ml16 days">
                周期共
                <span>{{ days }}</span> 天
              </div>
            </div>
          </el-form-item>
          <!-- 周扣时间选择 -->
          <div class="flex weekTime" v-if="formData.paymentMode === 2">
            <el-form-item
              prop="weekStartTime"
              label="扣款执行周期"
              :rules="{
                required: true,
                trigger: 'change',
                message: '请选择扣款开始时间',
              }"
            >
              <el-date-picker
                v-model="formData.weekStartTime"
                type="date"
                format="yyyy-MM-dd"
                placeholder="请选择"
                clearable
                :picker-options="weekStartPickerOptions"
                @change="changeStartTime"
              ></el-date-picker>
            </el-form-item>
            <div class="mb16 mr10">-</div>
            <el-form-item
              prop="weekEndTime"
              :rules="{
                required: true,
                trigger: 'change',
                message: '请选择扣款结束时间',
              }"
            >
              <el-date-picker
                :disabled="!formData.weekStartTime"
                v-model="formData.weekEndTime"
                type="date"
                placeholder="请选择"
                clearable
                :picker-options="weekEndPickerOptions"
              ></el-date-picker>
            </el-form-item>
            <div v-if="weeks" class="ml16 mb16 days">
              周期共
              <span>{{ weeks }}</span> 周
            </div>
          </div>
          <!-- 周扣模式下---周几开始扣款 -->
          <el-form-item
            v-if="formData.paymentMode === 2"
            class="minItem"
            prop="weekDay"
            label="按自然周拆分扣款计划每周"
            label-width="203px"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请选择扣款日',
            }"
            clearable
          >
            <el-select v-model="formData.weekDay" placeholder="请选择">
              <el-option
                v-for="week in weekList"
                :key="week.value"
                :label="week.label"
                :value="week.value"
              ></el-option>
            </el-select>
            <span class="ml10">开始扣款</span>
          </el-form-item>
          <el-form-item
            v-if="formData.paymentMode === 2"
            class="minItem"
            prop="limitAmount"
            :label="`按已选周期（${
              weeks || 'N'
            }周）自动拆分每周扣款金额，扣款金额不足`"
            label-width="396px"
            :rules="{
              required: true,
              trigger: 'change',
              message: '请输入最小扣款金额',
            }"
          >
            <el-input
              v-model="formData.limitAmount"
              v-limit-money
              v-delete-emoji
              placeholder="请输入"
            ></el-input>
            <span class="ml10">不进行周拆分</span>
          </el-form-item>
          <div v-if="formData.paymentMode === 1" class="dayRule mb16">
            日扣规则：每天按最大可提现金额扣款，直至扣满计划扣款金额
          </div>
        </el-form>
        <QS-h4-title title="扣款计划" no-decorate></QS-h4-title>
        <div class="plan_info">
          <el-button type="primary" @click="addFn">添加扣款应收</el-button>
          <div class="plan_info_con flex">
            <div class="mr16">
              <span>已选择扣款条目：</span>
              <span>{{ this.paginationData.total || 0 }}条</span>
            </div>
            <div>
              <span>扣款金额总计：</span>
              <span>{{ totalAmount }}元</span>
            </div>
          </div>
        </div>
      </div>
      <QS-common-table
        :loading="loading"
        :pagination="paginationData"
        class="mt16"
        :data="list"
        :columns="headData"
        @change="paginationChange"
      ></QS-common-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onOk">保 存</el-button>
      </span>
    </el-dialog>
    <CreateMoreWithhold
      :paramsData="formData"
      ref="CreateMoreWithhold"
      @success="setData"
    />
    <CreateError ref="CreateError" :errData="errData" />
  </div>
</template>
<script>
import moment from 'moment'
import CreateError from '@/pages/finance/collection/components/CreateError.vue'
import listMixins from '@/pages/finance/collection/mixins/planlist'
import CreateMoreWithhold from '@/pages/finance/collection/components/CreateMoreWithhold.vue'
import { receivableAccruedPreview, removeAccruedPreview, addAccruedPlan } from '@/api/financeApi'
import { mapState } from 'vuex'

export default {
  mixins: [listMixins],
  components: {
    CreateMoreWithhold, CreateError,
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      formData: {
        paymentMode: 1,
        gmtTime: '',
        limitAmount: 1000,
        weekDay: '',
        weekStartTime: '',
        weekEndTime: '',
      },
      pickerMinDate: '',
      pickerMaxDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            this.pickerMinDate = minDate.getTime()
          }
          if (maxDate) {
            this.pickerMinDate = ''
            this.pickerMaxDate = maxDate.getTime()
          }
        },
        disabledDate: (time) => {
          const day31 = 30 * 24 * 3600 * 1000
          const day1 = 1 * 24 * 3600 * 1000
          if (this.pickerMinDate !== '') {
            const maxTime = this.pickerMinDate + day31
            const minTime = this.pickerMinDate - day31
            // if (maxTime > new Date()) {
            //   maxTime = new Date()
            // }
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() < Date.now() - day1
          }
          return time.getTime() < Date.now() - day1
        },
      },
      weekStartPickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate) {
            this.weekPickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          const weekfirst = moment().weekday(1) // 本周第一天
          const day = new Date(time).getDay() // 获取time是周几
          // const week4 = 4 * 7 * 24 * 3600 * 1000 // 4周的时间戳
          const day1 = 24 * 3600 * 1000 // 一天的时间戳
          if (this.weekPickerMinDate !== '') {
            // return time.getTime() < weekfirst - day1 || day !== 1 || time.getTime() > this.weekPickerMinDate + week4 - day1 || time.getTime() < this.weekPickerMinDate - week4 + day1
          }
          return time.getTime() < weekfirst - day1 || day !== 1
        },
      },
      weekEndPickerOptions: {
        disabledDate: (time) => {
          const weekLast = moment(this.formData.weekStartTime).weekday(7) // 本周第一天
          const day = new Date(time).getDay() // 获取time是周几
          const week3 = 3 * 7 * 24 * 3600 * 1000 // 3周的时间戳
          return day !== 0 || time.getTime() < weekLast || time.getTime() > weekLast + week3
        },
      },
      days: '',
      totalAmount: 0,
      previewId: '',
      params: [],
      errData: [],
      weekList: [
        { label: '周一', value: 1 },
        { label: '周二', value: 2 },
        { label: '周三', value: 3 },
        { label: '周四', value: 4 },
        { label: '周五', value: 5 },
        { label: '周六', value: 6 },
        { label: '周日', value: 7 },
      ],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.submitLoading = false
      }
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
  },
  computed: {
    ...mapState({
      // eslint-disable-next-line vue/no-unused-properties -- 供 mixin planlist.js 表格列 getText 动态使用
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    weeks() {
      if (this.formData.weekStartTime && this.formData.weekEndTime) {
        return (moment(this.formData.weekEndTime).diff(moment(this.formData.weekStartTime), 'days') + 1) / 7
      }
      return 0
    },
  },
  methods: {
    paymentModeChange(e) {
      this.formData = {
        paymentMode: e,
        gmtTime: '',
        limitAmount: 1000,
        weekDay: '',
        weekStartTime: '',
        weekEndTime: '',
      }
      this.totalAmount = this.numberWithCommas(0)
      this.previewId = ''
      this.list = []
      this.paginationData.total = 0
      this.days = ''
    },
    // eslint-disable-next-line vue/no-unused-properties -- 供 mixin planlist.js 的 handleList 动态调用
    deteleItem(row, index) {
      removeAccruedPreview({
        previewId: this.previewId,
        accruedId: row.receivableId,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success('操作成功')
          this.paginationData.pageNum = 1
          this.getList()
        }
      })
    },
    setData(data) {
      this.paginationData.pageNum = 1
      this.paginationData.pageSize = 10
      this.paginationData.total = data.content.totalNum || 0
      this.list = data.content.items || []
      this.totalAmount = this.numberWithCommas(data.content.totalAmount || 0)
      this.previewId = data.content.previewId || ''
      this.params = data.params
    },
    getList() {
      this.loading = true
      const { paymentMode, limitAmount, weekDay, weekStartTime, weekEndTime } = this.formData
      const params = {
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
        accruedStartTime: this.params.accruedStartTime,
        accruedEndTime: this.params.accruedEndTime,
        content: this.params.content,
        accruedExeStartTime: paymentMode === 2 ? `${moment(weekStartTime).format('YYYY-MM-DD')} 00:00:00` : this.formData.gmtTime[0],
        accruedExeEndTime: paymentMode === 2 ? `${moment(weekEndTime).format('YYYY-MM-DD')} 23:59:59` : this.formData.gmtTime[1],
        accruedType: 1,
        previewId: this.previewId,
        paymentMode,
        limitAmount,
        weekDay,
      }
      receivableAccruedPreview(params).then((res) => {
        this.loading = false
        if (res.code === 1) {
          this.list = res.data.items || []
          this.paginationData.total = res.data.totalNum || 0
          this.totalAmount = this.numberWithCommas(res.data.totalAmount || 0)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    addFn() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // this.$refs.CreateMoreWithhold.closeDialog()
          this.$refs.CreateMoreWithhold.dialogVisible = true
        }
      })
    },
    closeDialog() {
      this.dialogVisible = false
      this.previewId = ''
      this.list = []
      this.$refs.formRef.resetFields()
      this.days = ''
      this.totalAmount = this.numberWithCommas(0)
      this.paginationData.total = 0
      this.formData.gmtTime = null
    },
    // 获取周期天数
    getTime(date) {
      if (!date) {
        this.days = ''
        return
      }
      if (date[1] && date[0]) {
        this.days = moment(date[1]).diff(moment(date[0]), 'days') + 1
      }
    },
    // 周扣开始时间改变
    changeStartTime() {
      this.formData.weekEndTime = ''
    },
    onOk() {
      if (this.submitLoading) return
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          if (this.paginationData.total === 0) {
            this.$message.error('请添加扣款应收')
            return
          }
          this.submitLoading = true
          const { paymentMode, limitAmount, weekDay, weekStartTime, weekEndTime } = this.formData
          const params = {
            accruedStartTime: this.params.accruedStartTime,
            accruedEndTime: this.params.accruedEndTime,
            content: this.params.content,
            accruedExeStartTime: paymentMode === 2 ? `${moment(weekStartTime).format('YYYY-MM-DD')} 00:00:00` : this.formData.gmtTime[0],
            accruedExeEndTime: paymentMode === 2 ? `${moment(weekEndTime).format('YYYY-MM-DD')} 23:59:59` : this.formData.gmtTime[1],
            accruedType: 1,
            previewId: this.previewId,
            paymentMode,
            limitAmount: paymentMode === 2 ? limitAmount : '',
            weekDay,
          }
          // console.log(params)
          addAccruedPlan(params).then((res) => {
            if (res.code !== 1) {
              this.submitLoading = false
              return
            }
            if (res.data && res.data.length > 0) {
              this.$refs.CreateError.dialogVisible = true
              this.errData = res.data
              this.submitLoading = false
              return
            }
            this.closeDialog()
            this.$message.success('操作成功')
            this.$emit('addSuccess')
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.dayRule {
  margin-left: 22px;
}
.flex {
  display: flex;
  align-items: center;
  .days {
    display: flex;
    align-items: center;
    color: #646566;
    span {
      color: #3d3d3d;
      font-size: 16px;
    }
  }
}
.plan_info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.minItem ::v-deep .el-input--small {
  width: 100px;
}
.weekTime ::v-deep .el-input--small {
  width: 120px;
}
.mr10 {
  margin-right: 10px;
}
.ml10 {
  margin-left: 10px;
}
</style>
